import { TFunction } from 'i18next'
import MssqlDatabaseRestService from '../rest/MssqlDatabaseRestService'

class MssqlDatabaseService {
  static async getPrimaryDatabase() {
    return MssqlDatabaseRestService.getPrimaryDatabase()
  }
  static async configurePrimaryDatabase(primaryDatabase: any, setPrimaryDatabase: React.Dispatch<any>, t: TFunction) {
    try {
      const noOfTasks: any = await MssqlDatabaseRestService.configurePrimaryDatabase(primaryDatabase)
      const updatedPrimaryDatabase = await MssqlDatabaseRestService.getPrimaryDatabase()
      setPrimaryDatabase(updatedPrimaryDatabase)
      return t('mssqlAdapter.configurePrimaryDatabaseSuccess', { noOfTasks: noOfTasks?.numberOfTasks })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default MssqlDatabaseService
